import React, { Component } from "react";
import BreadCrumbs from "../bcase/BreadCrumbs";
import Menu from "../bcase/Menu";
import Content from "../bcase/Content";
import { isNil, map, fromPairs, zip, some, pick } from "lodash";
import { batchRequest } from "../../api/ApiService";
import { Loader } from "react-loaders";
import { goBack } from "api/Location";

const dashboardStyle = {
  width: "100%"
};

const columnsStyle = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
};

const menuStyle = {
  paddingRight: 0
};

class BusinessCase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.initialState,
      currentRound: "",
      roundInUrl: props.roundInUrl,
      rounds: []
    };
  }

  get initialState() {
    return {
      initialDemand: null,
      salesClients: null,
      customerPreferences: null,
      customerDemands: null,
      constants: null,
      primeRates: null,
      demandGrowthRate: null,
      features: null,
      machines: null,
      debtClients: null,
      ratings: null,
      comparableCompanies: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.currentRound !== this.state.currentRound ||
      nextProps.roundInUrl !== this.state.roundInUrl ||
      nextProps.rounds !== this.state.rounds
    ) {
      this.setState(
        {
          currentRound: nextProps.currentRound,
          roundInUrl: nextProps.roundInUrl,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  componentDidMount() {
    this.setState(
      {
        currentRound: this.props.currentRound,
        roundInUrl: this.props.roundInUrl,
        rounds: this.props.rounds
      },
      () => {
        this.fetchData();
      }
    );
  }

  getRound = () => {
    const { currentRound, roundInUrl } = this.state;

    return roundInUrl !== null ? roundInUrl : currentRound;
  };

  fetchData = () => {
    const { rounds } = this.state;

    if (!rounds || rounds.length === 0) {
      return;
    }

    batchRequest(map(this.apiCalls, this.getUrlForCall)).then(res => {
      const newState = fromPairs(
        map(zip(res, this.apiCalls), ([{ body }, { key, zeroItem }]) => [
          key,
          !isNil(zeroItem) && !zeroItem ? body : body[0]
        ])
      );

      this.setState(newState);
    });
  };

  get apiCalls() {
    return [
      {
        url: "static/initial_demand",
        key: "initialDemand",
        zeroItem: true
      },
      {
        url: "static/sales_clients",
        key: "salesClients",
        zeroItem: false
      },
      {
        url: "static/customer_preferences",
        key: "customerPreferences",
        zeroItem: false
      },
      {
        url: "static/customer_demand",
        key: "customerDemands",
        zeroItem: false
      },
      {
        url: "static/constants",
        key: "constants",
        zeroItem: true
      },
      {
        url: "static/prime_rates",
        key: "primeRates",
        zeroItem: false
      },
      {
        url: "static/demand_growth_rate",
        key: "demandGrowthRate",
        zeroItem: false
      },
      {
        url: "static/features",
        key: "features",
        zeroItem: false
      },
      {
        url: "static/machines",
        key: "machines",
        zeroItem: false
      },
      {
        url: "static/debt_clients",
        key: "debtClients",
        zeroItem: false
      },
      {
        url: "static/ratings",
        key: "ratings",
        zeroItem: false
      },
      {
        url: "static/comparable_companies",
        key: "comparableCompanies",
        zeroItem: false
      }
    ];
  }

  getUrlForCall = call => {
    const round = this.getRound();

    return (
      `${process.env.REACT_APP_API_URL}${call.url}` +
      {
        false: () => "",
        undefined: () => `/?round_number=${round}`,
        lte: () => `/?round_lte=${round}`
      }[call.round]()
    );
  };

  get extendedState() {
    return {
      ...this.state,
      activeRound: this.getRound(),
      goBack: this.goBack
    };
  }

  goBack = () => {
    goBack();
  };

  ifLoaded = (fields, Component) => {
    return some(
      fields.filter(i => i !== "roundInUrl"),
      field => isNil(this.extendedState[field])
    ) ? (
      <Loader type="ball-scale-ripple" active />
    ) : (
      <Component {...pick(this.extendedState, fields)} />
    );
  };

  render() {
    const { location, params } = this.props;
    const { pathname, search } = location;
    const active = isNil(params.part) ? "" : params.part;

    return (
      <div className="dashboard" style={dashboardStyle}>
        <BreadCrumbs
          crumbs={[
            { label: "Home", location: "/start" },
            { label: "Analysis", location: "/analysis" },
            { label: "Business Case" }
          ]}
        />
        <div style={columnsStyle}>
          <div className="team-reports-menu" style={menuStyle}>
            <Menu location={pathname} search={search} />
          </div>
          <Content active={active} ifLoaded={this.ifLoaded} />
        </div>
      </div>
    );
  }
}

export default BusinessCase;



// WEBPACK FOOTER //
// ./src/components/dashboard/BusinessCase.js